import React, { Fragment } from 'react'

import Game from './Tripteez/Game.js'

export default function TTT () {
    return (
        <Fragment>
            <div id="heading">
                <h1>Play Walter</h1>
            </div>
            <section id="main" className="wrapper">
                <div className="inner">
                  <div className="content">
                    <Game />
                  </div>
                </div>
            </section>
        </Fragment>
    )
}
